import { render, staticRenderFns } from "./Price1Edit.vue?vue&type=template&id=feaec058&scoped=true"
import script from "./Price1Edit.vue?vue&type=script&lang=js"
export * from "./Price1Edit.vue?vue&type=script&lang=js"
import style0 from "./Price1Edit.vue?vue&type=style&index=0&id=feaec058&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feaec058",
  null
  
)

export default component.exports